import {loginErrorMessage} from './loginErrorMessage';
import {parseJSON} from './json';

const createResponse = (xhr, event) => ({
    status: xhr.status,
    readyState: xhr.readyState,
    type: xhr.responseType,
    url: xhr.responseURL,
    text: xhr.responseText,
    json: parseJSON(xhr.responseText),
    loaded: event.loaded,
    total: event.total
})

export const xhrWithTimeout = (url, opts = {}, onProgress) => {
    return new Promise((response, error) => {
        const xhr = new XMLHttpRequest();
        xhr.open(opts.method || 'get', url);
        xhr.withCredentials = true;

        for (let header in opts.headers || {}) {
            xhr.setRequestHeader(header, opts.headers[header]);
        }

        const csrfHeaderName = document.querySelector(
            'meta[name="swf-csrf-header-name"]')?.getAttribute('content');
        const csrfToken = document.querySelector(
            'meta[name="swf-csrf-token"]')?.getAttribute('content');
        if (csrfHeaderName && csrfToken) {
            xhr.setRequestHeader(csrfHeaderName, csrfToken);
        }

        xhr.timeout = opts.timeout || 30 * 1000;

        xhr.onload = event => {
            const status = xhr.status;
            const globalLoginError = document.getElementById('global-login-error');
            const remoteFailure = xhr.getResponseHeader('X-SimWorkflow-Error-Origin') === 'remote-service';
            if (!remoteFailure && [401, 403, 405].includes(status) && !globalLoginError) {
                const pageContent = document.querySelector('.ui.page-content');
                pageContent && pageContent.insertAdjacentHTML('afterbegin', loginErrorMessage);
            } else if (!remoteFailure && ![401, 403, 405].includes(status) && globalLoginError) {
                globalLoginError.remove();
            }

            response(createResponse(xhr, event));
        };

        xhr.onerror = event => error(createResponse(xhr, event));

        if (xhr.upload && onProgress) {
            xhr.upload.onprogress = onProgress;
        }

        xhr.send(opts.body);
    });
}
